import { useState, useRef } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { REGEX } from '@/backend/lib/regex';
import { I18n } from '@/i18n/I18n';
import { ParameterSourceLink } from './ParameterSourceLink';
import { useGetAllInputParametersForOperation } from '@/frontend/hooks/parameters';
import { Operation } from '@/backend/models/operation';

export const buildInterpolatedString = (value: string, operation: Operation) => {
  return value.split(/(<<[^>>]+>>)/).map((part, index) => {
    if (part.match(REGEX.PARAMETER_IDENTIFIER)) {
      return <span key={index} style={{ whiteSpace: 'pre-wrap', lineHeight: 1.7, maxWidth: '90%' }}><ParameterReference reference={part} operation={operation} /></span>;
    }
    return <span key={index} style={{ whiteSpace: 'pre-wrap', lineHeight: 1.7, maxWidth: '90%' }}>{part}</span>;
  });
};

export function ParameterReference(props: { reference: string, operation: Operation }) {
  const { reference, operation } = props;
  const parameters = useGetAllInputParametersForOperation(operation);

  const identifier = reference.replace(/<|>/g, '');
  const parameter = parameters.find(param => param.identifier === identifier);

  const parseValue = () => {
    if (parameter && parameter.concatArray()) {
      return parameter.concatArray();
    }
    return `<${I18n.get('noValue')}>`;
  };

  const displayValue = parseValue();
  const [show, setShow] = useState(false);
  const target = useRef(null);

  if (!parameter) {
    return (
      <OverlayTrigger
        show={show}
        placement="top"
        overlay={<Tooltip>
          {I18n.get('invalidInputReference', { match: identifier })}
        </Tooltip>}>
        <button type="button" className='border-0 bg-danger-subtle rounded' ref={target} onClick={() => setShow(!show)}>
          {identifier}
        </button>
      </OverlayTrigger>
    );
  }

  return (
    <OverlayTrigger
      show={show}
      placement="top"
      overlay={<Tooltip className='parameter-tooltip'>
        <ParameterSourceLink parameter={parameter} setShow={setShow} />
      </Tooltip>}>
      <button type="button" className='border-0 bg-secondary-subtle rounded text-muted text-truncate' style={{ maxWidth: '300px', maxHeight: '30px' }} ref={target} onClick={() => setShow(!show)}>
        {displayValue}
      </button>
    </OverlayTrigger>
  );
}
